import { createSlice } from "@reduxjs/toolkit";

export const applicationFeeSlice = createSlice({
  name: "applicationFee",
  initialState: {
    isDataFoundation: false,
    isApplicationFee: false,
    appicationFeeAllowedCourse: true,
  },
  reducers: {
    handleApplicationFee: (state, action) => {
      state.isApplicationFee = action.payload;
    },
    handleDataFoundation: (state, action) => {
      state.isDataFoundation = action.payload;
    },
    handleApplicationFeeAllowedCourse: (state, action) => {
      state.appicationFeeAllowedCourse = action.payload;
    },
  },
});

export const {
  handleDataFoundation,
  handleApplicationFee,
  handleApplicationFeeAllowedCourse,
} = applicationFeeSlice.actions;

export default applicationFeeSlice.reducer;
